const url = '/business/jgAttendanceStatistics/'
const dailyUrl = '/business/jgProjectDaily/'
const attendanceUrl = '/business/jgAttendanceStatistics/'
const machineryUrl = '/business/jgMachineryTeam/'
const api = {
  selectJgWorkerSum: url + 'selectJgWorkerSum',
  selecJgMachinerySum: url + 'selecJgMachinerySum',
  selecJgMaterialSum: url + 'selecJgMaterialSum',
  // 分页查询项目日报列表
  selectYhProjectDailyByPage: dailyUrl + 'selectYhProjectDailyByPage',
  // 查询项目日报详情
  selectYhProjectDailyByDailyId: dailyUrl + 'selectYhProjectDailyByDailyId',
  // 查询项目日报-明日计划
  selectDailyTomorrowPlan: dailyUrl + 'selectDailyTomorrowPlan',
  // 查询项目日报-养护作业
  selectDailyOrder: dailyUrl + 'selectDailyOrder',
  // 养护日报-劳务考勤
  selectLabourServiceStatisticByDaily: attendanceUrl + 'selectLabourServiceStatisticByDaily',
  // 机械台班
  selectJgMachineryTeamByList: machineryUrl + 'selectJgMachineryTeamByList',
  // 智慧养护 - 用工管理
  selectYhAttendanceCountV2:'/business/yhAttendanceCount/selectYhAttendanceCountV2'
}
export default api
